document.querySelectorAll('.HeaderSC *[data-open-filters], .ApartmentItemList__sort *[data-open-filters]').forEach((btn) => {
    const filtersEl = document.querySelector('.filters-container-block');

    btn.addEventListener('click', () => {
        document.body.classList.add('modal-open');
        filtersEl.classList.toggle('active');

        if (window.$isSmallPC) {
            filtersEl.classList.add('modal');
            filtersEl.classList.add('modal--right');
            openModal('.filters-container-block')
        }
    });

    if(filtersEl) {
        filtersEl.querySelector('*[data-search]').addEventListener('click', () => {
            filtersEl.classList.remove('active');
            document.body.classList.remove('modal-open');
        })
    }
});
document.querySelectorAll('.ApartmentItemList__sort .SelectBase input').forEach((sortEl) => {
    sortEl.addEventListener('change', () => {
        CookieUtil.set('sort', sortEl.value, filtersExpires, '/');
        document.dispatchEvent(new CustomEvent('main-filter-sort', { detail: sortEl.value }));
        location.reload();
    });
});

document.querySelectorAll('.filters-container-block, .IndexMainBlock').forEach(filtersMainInit);

function filtersMainInit(inputsContainer) {
    const container = document.querySelector('.HeaderSC__filters');
    const inputs = inputsContainer.querySelectorAll('input:not([name=modal-object])');
    const orderList = ((container ? container.dataset.order : null) || '').split(',').reverse();
    const disabledList = ((container ? container.dataset.disabled : null) || '').split(',');

    window.filtersMainAddFilter = addFilter;
    window.filtersMainRemoveFilter = remove;

    inputs.forEach((input) => {
        input.addEventListener('change', () => updateList(input));
        input.addEventListener('blur', () => updateList(input));
        input.addEventListener('paste', () => updateList(input));
    });

    if (container) {
        container.addEventListener('click', (e) => {
            const tag = e.target;
            if(window.isRestoringFilters) {
                return setTimeout(() => tag.click(), 100);
            }
            if (isCleanBtn(tag)) {
                document.dispatchEvent(new CustomEvent('main-filter-clean-all'));
                inputs.forEach(resetInput);
            } else if (isToggleAllBtn(tag)) {
                const state = container.classList.toggle('HeaderSC__filters--show');
                tag.innerText = state ? 'Скрыть' : 'Показать всё';
            } else if (tag !== container) {
                console.log('click tag', tag.innerText);
                const data = tag.dataset;
                let query = getQuery(data.name, data.value, 'input', '');
                let input = inputsContainer.querySelector(query);
                if (!input) {
                    let query = getQuery(data.name, null, 'input', '');
                    input = inputsContainer.querySelector(query)
                }
                if (input) {
                    resetInput(input);
                    tag.remove();
                } else {
                    console.warn('input not found', input, query, tag, inputsContainer, data);
                    window.filtersSendRemove({ name: data.name, value: data.value });
                }

                document.dispatchEvent(new CustomEvent('main-filter-remove', { detail: { ...data, input, tag } }));
            }
        });
    }

    function isCleanBtn(el) {
        return el.className.includes('HeaderSC__filters-clean');
    }
    function isToggleAllBtn(el) {
        return el.className.includes('HeaderSC__filters-all');
    }

    function resetInput(input) {
        if (input.type === 'radio' || input.type === 'checkbox') {
            input.checked = false;
        } else {
            input.value = '';
        }
        input.dispatchEvent(new Event('change'));
        input.dispatchEvent(new Event('reset'));
    }


    function updateList(input) {
        const classNameParent = input.parentElement.className;
        const _is = (str) => classNameParent.includes(str);

        if (_is('CheckboxTab__item') || _is('Checkbox') || _is('ToggleBase__item')) {
            const toggleBoolean = input.closest('.ToggleBoolean');
            if (input.value) {
                let checked = input.checked;
                if (toggleBoolean) {
                    checked = !toggleBoolean.querySelector('.ToggleBase__item:first-child input:checked');
                }
                if (input.type === 'radio') {
                    remove(input.name);
                }
                if (checked) {
                    const group = getFilterModalGroupName(input);
                    updateFilter(input.name, toggleBoolean ? '' : input.parentElement.innerText, group, input.value, false, toggleBoolean ? group : null);
                } else {
                    remove(input.name, input.value);
                }
            }
        } else if (_is('DoubleInput__inputs') || _is('SelectBase') || _is('InputBase') || _is('FilterPriceRange') || _is('FilterTypeHouse')) {
            const isNumber = _is('FilterPriceRange') || input.type === 'number';
            const defaultValue = cleanString(input.dataset.default);
            if (input.value && cleanString(input.value) !== defaultValue) {
                updateFilter(input.name, getLabel(input), getFilterModalGroupName(input), isNumber ? parseFloat(cleanString(input.value)) : input.value, !_is('FilterTypeHouse'));
            } else {
                remove(input.name);
            }
        } else if (_is('SearchableInput__input')) {
            remove(input.name);
            if (input.dataset.value) {
                updateFilter(input.name, getLabel(input), input.dataset.group, input.dataset.value, true);
                setOneCookieFilter(input.name, input.dataset.value);
                if(input.dataset.group === 'newbuild' && getCookieFilters()['general-category'].includes('5_6') && input.dataset.href) {
                    window.open(input.dataset.href, '_blank');
                }
            }
        } else {
            //console.log(input, classNameParent)
        }
    }

    function cleanString(str) {
        return str && str.replaceAll(' ', '').replaceAll(' ', '');
    }


    function getQuery(name, value = '', start = '*', prefix = 'data-') {
        let query = start;
        if (name) {
            query += `[${prefix}name="${name}"]`;
        }
        if (value) {
            query += `[${prefix}value="${value.toString()}"]`;
        }
        return query;
    }

    function getLabel(input) {
        if (input.dataset.label) {
            return input.dataset.label;
        }
        let label = input.value;
        const prefix = input.dataset.prefix;
        if (prefix) {
            label = prefix + label;
        }
        const unit = input.dataset.unit || '';
        /*if (input.placeholder && !input.placeholder.includes('+7')) {
            label = input.placeholder.replace(unit, '') + label;
        }*/
        if (unit) {
            label += ' ';
            label += unit;
        }
        return label;
    }

    function getFiler(name, value = '') {
        if (container && !window.isRestoringFilters) {
            return container.querySelectorAll(getQuery(name, value));
        } else {
            return [];
        }
    }

    function remove(name, value, valueInfo) {
        if (name || value) {
            getFiler(name, value).forEach((el) => el.remove());
            document.dispatchEvent(new CustomEvent('main-filter-change', {
                detail: {
                    name,
                    value: value || valueInfo,
                    remove: true,
                },
            }));
        }
    }

    function updateFilter(name, label, group = '', value = '', ignoreValue, groupTitle) {
        const el = getFiler(name, !ignoreValue && value)[0];
        if (ignoreValue) {
            document.dispatchEvent(new CustomEvent('main-filter-change', {
                detail: {
                    name,
                    label,
                    group,
                    remove: true,
                },
            }));
        }
        if (el) {
            el.innerHTML = getText(groupTitle, label);
            el.dataset.value = value;
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent('main-filter-change', {
                    detail: {
                        name,
                        value,
                        label,
                        group,
                        change: true,
                    },
                }));
            }, ignoreValue ? 100 : 1);
        } else {
            addFilter(name, value, label, groupTitle);
        }
    }

    function addFilter(name, value = '', label = '', group = '') {
        const isIgnoreTag = isMainFilter(name);
        if (!window.isRestoringFilters && container && !isIgnoreTag) {
            const order = getOrder(name) * -1;
            const disabled = isDisabled(name);
            container.innerHTML += `
            <div class="HeaderSC__tag ${disabled ? 'HeaderSC__tag--disabled' : ''}" data-name="${name}" data-value="${value}" style="order: ${order};">${getText(group, label)}</div>
            `;
        }
        document.dispatchEvent(new CustomEvent('main-filter-change', {
            detail: {
                name,
                value,
                label,
                group,
                add: true,
            },
        }));
    }

    function getOrder(name) {
        return orderList.indexOf(name) || 0;
    }

    function isDisabled(name) {
        return disabledList.includes(name);
    }

    function getText(group, label) {
        return `${group || ''}${(group && label) ? ': ' : ''}${label || ''}`;
    }

    function getFilterModalGroupName(el) {
        const item = getPreClosest(el, 'ModalAllFilters__list');
        if (item) {
            return item.previousElementSibling.innerText;
        }
    }
}

function getPreClosest(_el, findEl) {
    let el = _el, prev = el;
    while (el = el.parentElement) {
        if (el.className === 'ModalAllFilters__list') {
            return prev;
        }
        prev = el;
    }
}

(() => {
    //check filters
    const filtersEl = document.querySelector('.HeaderSC__filters');
    const cityTag = document.querySelector('.SearchableInput__tag ');
    document.addEventListener('main-filter-change', ({ detail }) => {
        if ((detail.name === 'metro' || detail.name === 'line') && !detail.remove) {
            removeFilter('address-city_district');
        } else if (detail.name === 'address-city_district' && !detail.remove) {
            removeFilter('metro');
        }

        if (detail.name === 'search_address') {
            updateCity();
        }
    });

    updateCity();

    function updateCity() {
        if (cityTag && filtersEl) {
            const el = filtersEl.querySelector('[data-name="search_address"]');
            if (el) {
                cityTag.innerHTML = el.innerHTML;
            }
        }
    }

    function removeFilter(name) {
        setOneCookieFilter(name);
        filtersEl.querySelectorAll(`[data-name="${name}"]`).forEach((tag) => {
            tag.click();
        });
    }
})();
